module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-003.18232ca4.jpg";